module.exports = __webpack_public_path__ + "media/application/images/svgs/stop-circle-361add7bc4cdf8ccb5b5c0067c77decf.svg";